import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class InstructionIsAdHocNoChangeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: number): Promise<boolean, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/InstructionIsAdHocNoChange/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<boolean, any>(url, data);
  }
  public put(instructionId: number, isAdHocNoChange: boolean): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/InstructionIsAdHocNoChange/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId, isAdHocNoChange: isAdHocNoChange }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
}

